const translations = {
    // english transaltions
    en: {
      footer: {
        aboutDesc:
          " Traincape Technology's specific methodologies for measuring and prioritizing customer satisfaction. Many companies use various methods to gauge and prioritize customer satisfaction.",
        workingTime: "Mon - Sat: 11AM - 7PM",
        sundayClosed: "Sunday Closed",
        address:
          "  Khandolia Plaza, 118C, Dabri - Palam Rd, Vaishali, Vaishali Colony, Dashrath Puri, New Delhi, Delhi, 110045",
        links: "Links",
        explore: "Explore",
        officeMap: "Office Map",
        contactUs: "Contact Us",
        workingHours: "Working Hours",
        officeAddress: "Office Address",
        aboutUs: "About Us",
        socialMediaLinks: "Social Media Links",
        faq: "FAQ",
        policy: "Policy",
        career: "Career",
        employee: "Employee",
        certificate: "Certificate",
        whatWeDo: "What We Do",
        resources: "Resources",
        internship: "Internship",
        partners: "Partners",
        gallery: "Gallery",
        copyRight: `Copyright © ${new Date().getFullYear()} `,
        allRightsReserved: "All rights reserved",
        company: "Company",
        services: "Services",
        products: "Products",
        industries: "Industries",
        technologies: "Technologies",
        trust: "Trust",
        googleRating: "Google Rating",
        countriesServed: "Countries Served",
        projectsDelivered: "Projects Delivered",
        support: "Support",
        yearsExperience: "Years Experience",
        businessHours: "Business Hours",
        phone: "Phone",
        email: "Email",
        office: "Office",
        news: "News",
      },
      aboutHeader: "About Traincape Technology",
      empowering:
        "Empowering careers through professional IT training and certification programs",
      home: "Home",
      aboutUs: "About Us",
      ourStory: "Our Story",
      storySubtitle:
        "The journey of Traincape Technology started with a vision to transform IT education",
      founder: "Founder & CEO",
      storyPara1:
        "Traincape Technology is committed to transforming how organizations harness the power of modern tech. We specialize in delivering smart, scalable solutions—from enterprise software to mobile apps—that solve real problems and drive measurable results.",
      storyPara2:
        "Our mission is simple: to empower individuals and businesses through cutting-edge digital tools, hands-on training, and globally recognized certifications. We don’t just build tech—we build futures.",
      storyPara3:
        "Backed by a team of experts and global partnerships, Traincape has helped professionals launch impactful careers and enabled companies to thrive in an ever-evolving digital landscape.",
      ourFoundation: "Our Foundation",
      foundationSubtitle:
        "The principles that guide everything we do at Traincape Technology",
      ourVision: "Our Vision",
      visionDesc:
        "To be the premier provider of IT education, recognized for excellence in training and producing industry-ready professionals who lead technological innovation.",
      ourMission: "Our Mission",
      missionDesc:
        "To empower individuals through comprehensive IT training programs that combine theoretical knowledge with practical skills, enabling them to excel in their careers.",
      ourValues: "Our Values",
      valuesDesc:
        "Excellence in education, integrity in our approach, innovation in our methods, and a commitment to the success of every student who trusts us with their professional development.",
      ourServices: "Our Services",
      servicesSubtitle:
        "Comprehensive IT training and technology solutions to advance your career",
      websiteDev: "Website Development",
      websiteDesc:
        "Custom website solutions tailored to your business needs, from simple informational sites to complex e-commerce platforms and web applications.",
      appDev: "App Development",
      appDesc:
        "Cross-platform mobile applications that provide seamless user experiences across iOS and Android devices, built with the latest technologies.",
      certVouchers: "Certification Vouchers",
      vouchersDesc:
        "Discounted exam vouchers for major IT certifications, making the path to professional certification more affordable and accessible.",
      internship: "Internship Programs",
      internshipDesc:
        "Gain practical experience through our structured internship programs, working on real-world projects under the guidance of experienced professionals.",
      profTraining: "Professional Training",
      trainingDesc:
        "Instructor-led training in various IT domains, including networking, cybersecurity, cloud computing, and software development.",
      freeAssess: "Free Assessment",
      assessDesc:
        "Comprehensive skill assessment to identify strengths and areas for improvement, helping you chart the best path for your professional development.",
      whyChoose: "Why Choose Traincape Technology",
      whySubtitle: "What sets us apart from other providers",
      expInstructors: "Industry-Experienced Instructors",
      instructorsDesc:
        "Learn from professionals with real-world experience in their fields",
      handsOn: "Hands-On Learning",
      handsOnDesc:
        "Practice-oriented training with real-world projects and exercises",
      careerSupport: "Career Support",
      careerDesc:
        "Resume assistance, interview preparation, and job placement support",
      customDev: "Custom Development",
      customDevDesc:
        "Tailored web and mobile applications designed to meet your specific business needs",
      modernTech: "Modern Technologies",
      modernTechDesc:
        "Development using the latest frameworks and technologies for optimal performance",
      ongoingSupport: "Ongoing Support",
      supportDesc:
        "Continuous maintenance and updates to ensure your applications stay current",
      certPartners: "Our Certification Partners",
      partnersSubtitle:
        "Prepare for globally recognized certifications with our authorized training programs",
      viewCourses: "View Courses",
      readyAdvance: "Ready to Advance Your IT Career?",
      careerHelp:
        "Whether you're looking to get certified, enhance your skills, or completely change your career path, we're here to help you succeed.",
      contactUs: "Contact Us",
      exploreCourses: "Explore Courses",
      comptiaDesc:
        "Prepare for core IT certifications like A+, Network+, Security+, and more with our CompTIA authorized training materials and experienced instructors.",
      pecbDesc:
        "Get certified in ISO standards, risk management, and information security with our PECB-accredited training programs.",
      microsoftDesc:
        "Master Microsoft technologies with our training programs for Azure, Microsoft 365, and developer certifications.",
    },
    // Hindi translations
    hi: {
      footer: {
        aboutDesc:
          "Traincape Technology की ग्राहक संतुष्टि को मापने और प्राथमिकता देने की विशिष्ट कार्यप्रणालियाँ। कई कंपनियाँ ग्राहक संतुष्टि को मापने और प्राथमिकता देने के विभिन्न तरीकों का उपयोग करती हैं।",
        workingTime: "सोम - शनि: 11AM - 7PM",
        sundayClosed: "रविवार बंद",
        address:
          "खंडोलिया प्लाज़ा, 118C, डाबरी - पालम रोड, वैशाली कॉलोनी, दशरथपुरी, नई दिल्ली, दिल्ली, 110045",
        links: "लिंक",
        explore: "खोजें",
        officeMap: "ऑफिस मैप",
        contactUs: "संपर्क करें",
        workingHours: "कार्य समय",
        officeAddress: "कार्यालय पता",
        aboutUs: "हमारे बारे में",
        socialMediaLinks: "सोशल मीडिया लिंक",
        faq: "प्रश्नोत्तर",
        policy: "नीति",
        career: "करियर",
        employee: "कर्मचारी",
        whatWeDo: "हम क्या करते हैं",
        resources: "संसाधन",
        internship: "इंटर्नशिप",
        partners: "साझेदार",
        gallery: "गैलरी",
        copyRight: "कॉपीराइट © " + new Date().getFullYear(),
        allRightsReserved: "सर्वाधिकार सुरक्षित",
        company: "कंपनी",
        services: "सेवाएं",
        products: "उत्पाद",
        industries: "उद्योग",
        technologies: "तकनीकें",
        trust: "विश्वास",
        googleRating: "गूगल रेटिंग",
        countriesServed: "देश सेवा की",
        projectsDelivered: "पूर्ण परियोजनाएं",
        support: "सहायता",
        yearsExperience: "वर्षों का अनुभव",
        businessHours: "व्यवसायिक घंटे",
        phone: "फोन",
        email: "ईमेल",
        office: "कार्यालय",
        news: "समाचार",
      },
      aboutHeader: "ट्रेनकेप टेक्नोलॉजी के बारे में",
      empowering:
        "पेशेवर आईटी प्रशिक्षण और प्रमाणीकरण कार्यक्रमों के माध्यम से करियर को सशक्त बनाना",
      home: "होम",
      aboutUs: "हमारे बारे में",
      ourStory: "हमारी कहानी",
      storySubtitle:
        "ट्रेनकेप टेक्नोलॉजी की यात्रा आईटी शिक्षा को बदलने के दृष्टिकोण से शुरू हुई",
      founder: "संस्थापक और सीईओ",
      storyPara1:
        "ट्रेनकेप टेक्नोलॉजी की स्थापना 2021 में परिचय सिंह राणा द्वारा व्यवसायों को तकनीक के प्रति अपने दृष्टिकोण को क्रांतिकारी बनाने के दृष्टिकोण के साथ की गई थी। उद्योग में वर्षों के अनुभव के साथ, हमने एक ऐसी कंपनी की आवश्यकता को पहचाना जो अनुकूलित, विश्वसनीय और अत्याधुनिक तकनीकी समाधान प्रदान कर सके।",
      storyPara2:
        "हमारा मिशन व्यवसायों को नवीनतम तकनीकों और नवाचारों का लाभ उठाकर विकास, दक्षता और नवाचार को बढ़ावा देना है। हमारी विशेषज्ञों की टीम को कस्टम सॉफ्टवेयर समाधान, मोबाइल ऐप और वेब एप्लिकेशन विकसित और कार्यान्वित करने का व्यापक अनुभव है जो हमारे ग्राहकों की विशिष्ट आवश्यकताओं को पूरा करते हैं।",
      storyPara3:
        "आज, हमें अनेक पेशेवरों को प्रशिक्षित करने पर गर्व है जो प्रमुख तकनीकी कंपनियों में भूमिकाएं हासिल कर चुके हैं। प्रमुख प्रमाणन निकायों के साथ हमारी साझेदारी हमें व्यापक प्रशिक्षण कार्यक्रम प्रदान करने में सक्षम बनाती है जो विश्व स्तर पर मान्यता प्राप्त हैं।",
      ourFoundation: "हमारी नींव",
      foundationSubtitle:
        "वे सिद्धांत जो ट्रेनकेप टेक्नोलॉजी में हमारे हर काम का मार्गदर्शन करते हैं",
      ourVision: "हमारी दृष्टि",
      visionDesc:
        "आईटी शिक्षा का प्रमुख प्रदाता बनना, जो प्रशिक्षण में उत्कृष्टता और उद्योग-तैयार पेशेवरों को तैयार करने के लिए मान्यता प्राप्त है जो तकनीकी नवाचार का नेतृत्व करते हैं।",
      ourMission: "हमारा मिशन",
      missionDesc:
        "व्यापक आईटी प्रशिक्षण कार्यक्रमों के माध्यम से व्यक्तियों को सशक्त बनाना जो सैद्धांतिक ज्ञान को व्यावहारिक कौशल के साथ जोड़ते हैं, जिससे उन्हें अपने करियर में उत्कृष्टता प्राप्त करने में सक्षम बनाया जा सके।",
      ourValues: "हमारे मूल्य",
      valuesDesc:
        "शिक्षा में उत्कृष्टता, हमारे दृष्टिकोण में अखंडता, हमारी विधियों में नवाचार, और हर उस छात्र की सफलता के प्रति प्रतिबद्धता जो अपने पेशेवर विकास के लिए हम पर भरोसा करता है।",
      ourServices: "हमारी सेवाएं",
      servicesSubtitle:
        "आपके करियर को आगे बढ़ाने के लिए व्यापक आईटी प्रशिक्षण और प्रौद्योगिकी समाधान",
      websiteDev: "वेबसाइट विकास",
      websiteDesc:
        "आपकी व्यवसायिक आवश्यकताओं के अनुरूप कस्टम वेबसाइट समाधान, सरल सूचनात्मक साइटों से लेकर जटिल ई-कॉमर्स प्लेटफॉर्म और वेब एप्लिकेशन तक।",
      appDev: "ऐप विकास",
      appDesc:
        "क्रॉस-प्लेटफॉर्म मोबाइल एप्लिकेशन जो आईओएस और एंड्रॉइड डिवाइसों पर निर्बाध उपयोगकर्ता अनुभव प्रदान करते हैं, नवीनतम तकनीकों के साथ निर्मित।",
      certVouchers: "प्रमाणन वाउचर",
      vouchersDesc:
        "प्रमुख आईटी प्रमाणनों के लिए रियायती परीक्षा वाउचर, जो पेशेवर प्रमाणन के मार्ग को अधिक किफायती और सुलभ बनाते हैं।",
      internship: "इंटर्नशिप प्रोग्राम",
      internshipDesc:
        "हमारे संरचित इंटर्नशिप कार्यक्रमों के माध्यम से व्यावहारिक अनुभव प्राप्त करें, अनुभवी पेशेवरों के मार्गदर्शन में वास्तविक दुनिया की परियोजनाओं पर काम करें।",
      profTraining: "पेशेवर प्रशिक्षण",
      trainingDesc:
        "विभिन्न आईटी डोमेन में प्रशिक्षक-नेतृत्व वाला प्रशिक्षण, जिसमें नेटवर्किंग, साइबर सुरक्षा, क्लाउड कंप्यूटिंग और सॉफ्टवेयर विकास शामिल हैं।",
      freeAssess: "मुफ्त मूल्यांकन",
      assessDesc:
        "शक्तियों और सुधार के क्षेत्रों की पहचान करने के लिए व्यापक कौशल मूल्यांकन, जो आपको अपने पेशेवर विकास के लिए सर्वोत्तम मार्ग चुनने में मदद करता है।",
      whyChoose: "ट्रेनकेप टेक्नोलॉजी को क्यों चुनें",
      whySubtitle: "वह क्या है जो हमें अन्य प्रदाताओं से अलग करता है",
      expInstructors: "उद्योग-अनुभवी प्रशिक्षक",
      instructorsDesc:
        "अपने क्षेत्रों में वास्तविक दुनिया के अनुभव वाले पेशेवरों से सीखें",
      handsOn: "व्यावहारिक सीखना",
      handsOnDesc:
        "वास्तविक दुनिया की परियोजनाओं और अभ्यासों के साथ अभ्यास-उन्मुख प्रशिक्षण",
      careerSupport: "करियर सहायता",
      careerDesc:
        "रिज्यूमे सहायता, साक्षात्कार तैयारी, और नौकरी प्लेसमेंट सहायता",
      customDev: "कस्टम विकास",
      customDevDesc:
        "आपकी विशिष्ट व्यावसायिक आवश्यकताओं को पूरा करने के लिए अनुकूलित वेब और मोबाइल एप्लिकेशन",
      modernTech: "आधुनिक तकनीकें",
      modernTechDesc:
        "इष्टतम प्रदर्शन के लिए नवीनतम फ्रेमवर्क और तकनीकों का उपयोग करके विकास",
      ongoingSupport: "निरंतर समर्थन",
      supportDesc:
        "आपके एप्लिकेशन को अप-टू-डेट रखने के लिए निरंतर रखरखाव और अपडेट",
      certPartners: "हमारे प्रमाणन भागीदार",
      partnersSubtitle:
        "हमारे अधिकृत प्रशिक्षण कार्यक्रमों के साथ विश्व स्तर पर मान्यता प्राप्त प्रमाणनों के लिए तैयारी करें",
      viewCourses: "कोर्स देखें",
      readyAdvance: "अपने आईटी करियर को आगे बढ़ाने के लिए तैयार हैं?",
      careerHelp:
        "चाहे आप प्रमाणित होना चाहते हों, अपने कौशल को बढ़ाना चाहते हों, या अपने करियर पथ को पूरी तरह से बदलना चाहते हों, हम आपको सफल होने में मदद करने के लिए यहां हैं।",
      contactUs: "संपर्क करें",
      exploreCourses: "कोर्स एक्सप्लोर करें",
      comptiaDesc:
        "हमारे CompTIA अधिकृत प्रशिक्षण सामग्री और अनुभवी प्रशिक्षकों के साथ A+, Network+, Security+ जैसे मुख्य आईटी प्रमाणनों के लिए तैयारी करें।",
      pecbDesc:
        "हमारे PECB-मान्यता प्राप्त प्रशिक्षण कार्यक्रमों के साथ ISO मानकों, जोखिम प्रबंधन और सूचना सुरक्षा में प्रमाणित हों।",
      microsoftDesc:
        "Azure, Microsoft 365 और डेवलपर प्रमाणनों के लिए हमारे प्रशिक्षण कार्यक्रमों के साथ Microsoft तकनीकों में महारत हासिल करें।",
    },
    // Dutch translations
    nl: {
      footer: {
        aboutDesc:
          "Traincape Technology's specifieke methodologieën voor het meten en prioriteren van klanttevredenheid. Veel bedrijven gebruiken verschillende methoden om klanttevredenheid te meten en te prioriteren.",
        workingTime: "Ma - Za: 11AM - 7PM",
        sundayClosed: "Zondag Gesloten",
        address:
          "Khandolia Plaza, 118C, Dabri - Palam Rd, Vaishali, Vaishali Colony, Dashrath Puri, New Delhi, Delhi, 110045",
        links: "Links",
        explore: "Verkennen",
        officeMap: "Kantoorplattegrond",
        contactUs: "Neem Contact Op",
        workingHours: "Werkuren",
        officeAddress: "Kantooradres",
        aboutUs: "Over Ons",
        socialMediaLinks: "Sociale Media Links",
        faq: "FAQ",
        policy: "Beleid",
        career: "Carrière",
        employee: "Werknemer",
        whatWeDo: "Wat We Doen",
        resources: "Bronnen",
        internship: "Stage",
        partners: "Partners",
        gallery: "Galerij",
        copyRight: "Copyright © " + new Date().getFullYear(),
        allRightsReserved: "Alle rechten voorbehouden",
        company: "Bedrijf",
        services: "Diensten",
        products: "Producten",
        industries: "Industrieën",
        technologies: "Technologieën",
        trust: "Vertrouwen",
        googleRating: "Google Beoordeling",
        countriesServed: "Landen Bediend",
        projectsDelivered: "Geleverde Projecten",
        support: "Ondersteuning",
        yearsExperience: "Jaren Ervaring",
        businessHours: "Kantooruren",
        phone: "Telefoon",
        email: "E-mail",
        office: "Kantoor",
        news: "Nieuws",
      },
      aboutHeader: "Over Traincape Technology",
      empowering:
        "Carrières versterken door professionele IT-training en certificeringsprogramma's",
      home: "Home",
      aboutUs: "Over Ons",
      ourStory: "Ons Verhaal",
      storySubtitle:
        "De reis van Traincape Technology begon met een visie om IT-onderwijs te transformeren",
      founder: "Oprichter & CEO",
      storyPara1:
        "Traincape Technology werd in 2021 opgericht door Parichay Singh Rana met een visie om de manier waarop bedrijven technologie benaderen te revolutioneren. Met jarenlange ervaring in de industrie erkenden we de behoefte aan een bedrijf dat op maat gemaakte, betrouwbare en geavanceerde technologische oplossingen kon bieden.",
      storyPara2:
        "Onze missie is om bedrijven te versterken door gebruik te maken van de nieuwste technologieën en innovaties om groei, efficiëntie en innovatie te stimuleren. Ons team van experts heeft uitgebreide ervaring in het ontwikkelen en implementeren van aangepaste softwareoplossingen, mobiele apps en webapplicaties die voldoen aan de unieke behoeften van onze klanten.",
      storyPara3:
        "Vandaag zijn we er trots op dat we talloze professionals hebben opgeleid die functies hebben verworven bij toonaangevende technologiebedrijven. Onze partnerschappen met belangrijke certificeringsinstanties stellen ons in staat om uitgebreide trainingsprogramma's aan te bieden die wereldwijd worden erkend.",
      ourFoundation: "Onze Basis",
      foundationSubtitle:
        "De principes die alles wat we doen bij Traincape Technology leiden",
      ourVision: "Onze Visie",
      visionDesc:
        "Om de voornaamste aanbieder van IT-onderwijs te zijn, erkend voor uitmuntendheid in training en het produceren van industrie-klare professionals die technologische innovatie leiden.",
      ourMission: "Onze Missie",
      missionDesc:
        "Om individuen te versterken door middel van uitgebreide IT-trainingsprogramma's die theoretische kennis combineren met praktische vaardigheden, waardoor ze kunnen excelleren in hun carrières.",
      ourValues: "Onze Waarden",
      valuesDesc:
        "Uitmuntendheid in onderwijs, integriteit in onze aanpak, innovatie in onze methoden, en een toewijding aan het succes van elke student die ons vertrouwt met hun professionele ontwikkeling.",
      ourServices: "Onze Diensten",
      servicesSubtitle:
        "Uitgebreide IT-training en technologische oplossingen om je carrière vooruit te helpen",
      websiteDev: "Website Ontwikkeling",
      websiteDesc:
        "Aangepaste websiteoplossingen op maat van uw bedrijfsbehoeften, van eenvoudige informatieve sites tot complexe e-commerceplatforms en webapplicaties.",
      appDev: "App Ontwikkeling",
      appDesc:
        "Cross-platform mobiele applicaties die een naadloze gebruikerservaring bieden op iOS- en Android-apparaten, gebouwd met de nieuwste technologieën.",
      certVouchers: "Certificeringsvouchers",
      vouchersDesc:
        "Kortingsvouchers voor belangrijke IT-certificeringsexamens, waardoor de weg naar professionele certificering betaalbaarder en toegankelijker wordt.",
      internship: "Stageprogramma's",
      internshipDesc:
        "Verkrijg praktische ervaring via onze gestructureerde stageprogramma's, door te werken aan echte projecten onder begeleiding van ervaren professionals.",
      profTraining: "Professionele Training",
      trainingDesc:
        "Door instructeurs geleide training in verschillende IT-domeinen, waaronder netwerken, cybersecurity, cloud computing en softwareontwikkeling.",
      freeAssess: "Gratis Beoordeling",
      assessDesc:
        "Uitgebreide vaardighedenbeoordeling om sterke punten en verbeterpunten te identificeren, om je te helpen de beste weg voor je professionele ontwikkeling uit te stippelen.",
      whyChoose: "Waarom Kiezen voor Traincape Technology",
      whySubtitle: "Wat ons onderscheidt van andere aanbieders",
      expInstructors: "Instructeurs met Industrie-Ervaring",
      instructorsDesc:
        "Leer van professionals met praktijkervaring in hun vakgebieden",
      handsOn: "Praktijkgericht Leren",
      handsOnDesc: "Praktijkgerichte training met echte projecten en oefeningen",
      careerSupport: "Carrière Ondersteuning",
      careerDesc:
        "CV-hulp, interviewvoorbereiding en ondersteuning bij het vinden van een baan",
      customDev: "Aangepaste Ontwikkeling",
      customDevDesc:
        "Op maat gemaakte web- en mobiele applicaties ontworpen om aan uw specifieke bedrijfsbehoeften te voldoen",
      modernTech: "Moderne Technologieën",
      modernTechDesc:
        "Ontwikkeling met behulp van de nieuwste frameworks en technologieën voor optimale prestaties",
      ongoingSupport: "Doorlopende Ondersteuning",
      supportDesc:
        "Continue onderhoud en updates om ervoor te zorgen dat uw applicaties up-to-date blijven",
      certPartners: "Onze Certificeringspartners",
      partnersSubtitle:
        "Bereid je voor op wereldwijd erkende certificeringen met onze geautoriseerde trainingsprogramma's",
      viewCourses: "Bekijk Cursussen",
      readyAdvance: "Klaar om je IT-carrière vooruit te helpen?",
      careerHelp:
        "Of je nu op zoek bent naar certificering, je vaardigheden wilt verbeteren of je carrièrepad volledig wilt veranderen, wij zijn er om je te helpen slagen.",
      contactUs: "Neem Contact Op",
      exploreCourses: "Verken Cursussen",
      comptiaDesc:
        "Bereid je voor op kern-IT-certificeringen zoals A+, Network+, Security+ en meer met onze CompTIA geautoriseerde trainingsmaterialen en ervaren instructeurs.",
      pecbDesc:
        "Word gecertificeerd in ISO-normen, risicobeheer en informatiebeveiliging met onze PECB-geaccrediteerde trainingsprogramma's.",
      microsoftDesc:
        "Beheers Microsoft-technologieën met onze trainingsprogramma's voor Azure, Microsoft 365 en ontwikkelaarscertificeringen.",
    },
    // French translations
    fr: {
      footer: {
        aboutDesc:
          "Les méthodologies spécifiques de Traincape Technology pour mesurer et prioriser la satisfaction client. De nombreuses entreprises utilisent diverses méthodes pour évaluer et prioriser la satisfaction de leurs clients.",
        workingTime: "Lun - Sam : 11h00 - 19h00",
        sundayClosed: "Dimanche Fermé",
        address:
          "Khandolia Plaza, 118C, Dabri - Palam Rd, Vaishali, Vaishali Colony, Dashrath Puri, New Delhi, Delhi, 110045",
        links: "Liens",
        explore: "Explorer",
        officeMap: "Plan du bureau",
        contactUs: "Nous contacter",
        workingHours: "Heures de travail",
        officeAddress: "Adresse du bureau",
        aboutUs: "À propos de nous",
        socialMediaLinks: "Liens des réseaux sociaux",
        faq: "FAQ",
        policy: "Politique",
        career: "Carrière",
        employee: "Employé",
        whatWeDo: "Ce que nous faisons",
        resources: "Ressources",
        internship: "Stage",
        partners: "Partenaires",
        gallery: "Galerie",
        copyRight: "Copyright © " + new Date().getFullYear(),
        allRightsReserved: "Tous droits réservés",
        company: "Entreprise",
        services: "Services",
        products: "Produits",
        industries: "Secteurs",
        technologies: "Technologies",
        trust: "Confiance",
        googleRating: "Note Google",
        countriesServed: "Pays Desservis",
        projectsDelivered: "Projets Livrés",
        support: "Support",
        yearsExperience: "Années d'Expérience",
        businessHours: "Heures de bureau",
        phone: "Téléphone",
        email: "E-mail",
        office: "Bureau",
        news: "Actualités",
      },
      aboutHeader: "À propos de Traincape Technology",
      empowering:
        "Propulser les carrières grâce à des programmes de formation professionnelle en informatique et de certification",
      home: "Accueil",
      aboutUs: "À propos de nous",
      ourStory: "Notre Histoire",
      storySubtitle:
        "Le parcours de Traincape Technology a commencé avec une vision de transformer l'éducation informatique",
      founder: "Fondateur et PDG",
      storyPara1:
        "Traincape Technology a été fondée en 2021 par Parichay Singh Rana avec la vision de révolutionner la façon dont les entreprises abordent la technologie. Avec des années d'expérience dans l'industrie, nous avons reconnu le besoin d'une entreprise capable de fournir des solutions technologiques personnalisées, fiables et à la pointe.",
      storyPara2:
        "Notre mission est de donner aux entreprises les moyens de tirer parti des dernières technologies et innovations pour stimuler la croissance, l'efficacité et l'innovation. Notre équipe d'experts possède une vaste expérience dans le développement et la mise en œuvre de solutions logicielles personnalisées, d'applications mobiles et d'applications web qui répondent aux besoins uniques de nos clients.",
      storyPara3:
        "Aujourd'hui, nous sommes fiers d'avoir formé de nombreux professionnels qui ont obtenu des postes au sein d'entreprises technologiques de premier plan. Nos partenariats avec les principaux organismes de certification nous permettent d'offrir des programmes de formation complets reconnus mondialement.",
      ourFoundation: "Notre Fondation",
      foundationSubtitle:
        "Les principes qui guident tout ce que nous faisons chez Traincape Technology",
      ourVision: "Notre Vision",
      visionDesc:
        "Être le principal fournisseur d'éducation informatique, reconnu pour l'excellence de la formation et la production de professionnels prêts pour l'industrie qui dirigent l'innovation technologique.",
      ourMission: "Notre Mission",
      missionDesc:
        "Permettre aux individus de s'épanouir grâce à des programmes de formation informatique complets qui combinent connaissances théoriques et compétences pratiques, leur permettant d'exceller dans leurs carrières.",
      ourValues: "Nos Valeurs",
      valuesDesc:
        "L'excellence dans l'éducation, l'intégrité dans notre approche, l'innovation dans nos méthodes et un engagement envers le succès de chaque étudiant qui nous confie son développement professionnel.",
      ourServices: "Nos Services",
      servicesSubtitle:
        "Formation informatique complète et solutions technologiques pour faire progresser votre carrière",
      websiteDev: "Développement de Sites Web",
      websiteDesc:
        "Solutions de sites web personnalisées adaptées aux besoins de votre entreprise, des sites d'information simples aux plateformes e-commerce complexes et applications web.",
      appDev: "Développement d'Applications",
      appDesc:
        "Applications mobiles multiplateformes offrant une expérience utilisateur fluide sur les appareils iOS et Android, construites avec les dernières technologies.",
      certVouchers: "Bons de Certification",
      vouchersDesc:
        "Bons d'examen à prix réduit pour les principales certifications informatiques, rendant le chemin vers la certification professionnelle plus abordable et accessible.",
      internship: "Programmes de Stage",
      internshipDesc:
        "Acquérir une expérience pratique grâce à nos programmes de stage structurés, en travaillant sur des projets réels sous la direction de professionnels expérimentés.",
      profTraining: "Formation Professionnelle",
      trainingDesc:
        "Formation dirigée par un instructeur dans divers domaines informatiques, notamment les réseaux, la cybersécurité, l'informatique en nuage et le développement de logiciels.",
      freeAssess: "Évaluation Gratuite",
      assessDesc:
        "Évaluation complète des compétences pour identifier les forces et les domaines à améliorer, vous aidant à tracer la meilleure voie pour votre développement professionnel.",
      whyChoose: "Pourquoi Choisir Traincape Technology",
      whySubtitle: "Ce qui nous distingue des autres fournisseurs",
      expInstructors: "Instructeurs Expérimentés dans l'Industrie",
      instructorsDesc:
        "Apprenez de professionnels ayant une expérience réelle dans leurs domaines",
      handsOn: "Apprentissage Pratique",
      handsOnDesc:
        "Formation orientée vers la pratique avec des projets et des exercices réels",
      careerSupport: "Soutien de Carrière",
      careerDesc:
        "Assistance pour le CV, préparation aux entretiens et aide au placement professionnel",
      customDev: "Développement Personnalisé",
      customDevDesc:
        "Applications web et mobiles sur mesure conçues pour répondre à vos besoins professionnels spécifiques",
      modernTech: "Technologies Modernes",
      modernTechDesc:
        "Développement utilisant les derniers frameworks et technologies pour des performances optimales",
      ongoingSupport: "Support Continu",
      supportDesc:
        "Maintenance et mises à jour continues pour garantir que vos applications restent à jour",
      certPartners: "Nos Partenaires de Certification",
      partnersSubtitle:
        "Préparez-vous aux certifications mondialement reconnues avec nos programmes de formation autorisés",
      viewCourses: "Voir les Cours",
      readyAdvance: "Prêt à faire progresser votre carrière informatique?",
      careerHelp:
        "Que vous cherchiez à obtenir une certification, à améliorer vos compétences ou à changer complètement de parcours professionnel, nous sommes là pour vous aider à réussir.",
      contactUs: "Contactez-Nous",
      exploreCourses: "Explorer les Cours",
      comptiaDesc:
        "Préparez-vous aux certifications informatiques de base comme A+, Network+, Security+ et plus encore avec nos supports de formation autorisés par CompTIA et nos instructeurs expérimentés.",
      pecbDesc:
        "Obtenez une certification dans les normes ISO, la gestion des risques et la sécurité de l'information avec nos programmes de formation accrédités par PECB.",
      microsoftDesc:
        "Maîtrisez les technologies Microsoft avec nos programmes de formation pour les certifications Azure, Microsoft 365 et développeur.",
    },
  
    // Portuguese translations
    pt: {
      footer: {
        aboutDesc:
          "Metodologias específicas da Traincape Technology para medir e priorizar a satisfação do cliente. Muitas empresas usam vários métodos para medir e priorizar a satisfação do cliente.",
        workingTime: "Seg - Sáb: 11AM - 7PM",
        address:
          "Khandolia Plaza, 118C, Dabri - Palam Rd, Vaishali, Vaishali Colony, Dashrath Puri, Nova Deli, Deli, 110045",
        links: "Links",
        explore: "Explorar",
        officeMap: "Mapa do Escritório",
        contactUs: "Contate-Nos",
        workingHours: "Horário de Trabalho",
        officeAddress: "Endereço do Escritório",
        aboutUs: "Sobre Nós",
        socialMediaLinks: "Links de Mídia Social",
        faq: "FAQ",
        policy: "Política",
        career: "Carreira",
        employee: "Funcionário",
        whatWeDo: "O que Fazemos",
        resources: "Recursos",
        internship: "Estágio",
        partners: "Parceiros",
        gallery: "Galeria",
        copyRight: "Copyright © " + new Date().getFullYear(),
        allRightsReserved: "Todos os direitos reservados",
      },
      aboutHeader: "Sobre a Traincape Technology",
      empowering:
        "Capacitando carreiras através de programas profissionais de treinamento e certificação em TI",
      home: "Início",
      aboutUs: "Sobre Nós",
      ourStory: "Nossa História",
      storySubtitle:
        "A jornada da Traincape Technology começou com uma visão de transformar a educação em TI",
      founder: "Fundador e CEO",
      storyPara1:
        "A Traincape Technology foi fundada em 2021 por Parichay Singh Rana com a visão de revolucionar a forma como as empresas abordam a tecnologia. Com anos de experiência no setor, reconhecemos a necessidade de uma empresa que pudesse fornecer soluções tecnológicas personalizadas, confiáveis e de ponta.",
      storyPara2:
        "Nossa missão é capacitar empresas, aproveitando as mais recentes tecnologias e inovações para impulsionar o crescimento, a eficiência e a inovação. Nossa equipe de especialistas tem ampla experiência no desenvolvimento e implementação de soluções de software personalizadas, aplicativos móveis e aplicações web que atendem às necessidades únicas de nossos clientes.",
      storyPara3:
        "Hoje, temos orgulho de ter treinado inúmeros profissionais que conseguiram garantir funções em empresas líderes de tecnologia. Nossas parcerias com os principais órgãos de certificação nos permitem oferecer programas de treinamento abrangentes que são reconhecidos globalmente.",
      ourFoundation: "Nossa Fundação",
      foundationSubtitle:
        "Os princípios que orientam tudo o que fazemos na Traincape Technology",
      ourVision: "Nossa Visão",
      visionDesc:
        "Ser o principal provedor de educação em TI, reconhecido pela excelência em treinamento e pela produção de profissionais prontos para a indústria que lideram a inovação tecnológica.",
      ourMission: "Nossa Missão",
      missionDesc:
        "Capacitar indivíduos através de programas abrangentes de treinamento em TI que combinam conhecimento teórico com habilidades práticas, permitindo-lhes se destacar em suas carreiras.",
      ourValues: "Nossos Valores",
      valuesDesc:
        "Excelência na educação, integridade em nossa abordagem, inovação em nossos métodos e um compromisso com o sucesso de cada estudante que confia em nós para seu desenvolvimento profissional.",
      ourServices: "Nossos Serviços",
      servicesSubtitle:
        "Treinamento abrangente em TI e soluções tecnológicas para avançar em sua carreira",
      websiteDev: "Desenvolvimento de Sites",
      websiteDesc:
        "Soluções de sites personalizados adaptados às necessidades do seu negócio, desde sites informativos simples até plataformas complexas de e-commerce e aplicações web.",
      appDev: "Desenvolvimento de Aplicativos",
      appDesc:
        "Aplicativos móveis multiplataforma que proporcionam experiências de usuário perfeitas em dispositivos iOS e Android, construídos com as mais recentes tecnologias.",
      certVouchers: "Vouchers de Certificação",
      vouchersDesc:
        "Vouchers de exame com desconto para as principais certificações de TI, tornando o caminho para a certificação profissional mais acessível e econômico.",
      internship: "Programas de Estágio",
      internshipDesc:
        "Obtenha experiência prática através de nossos programas de estágio estruturados, trabalhando em projetos do mundo real sob a orientação de profissionais experientes.",
      profTraining: "Treinamento Profissional",
      trainingDesc:
        "Treinamento com instrutor em vários domínios de TI, incluindo redes, cibersegurança, computação em nuvem e desenvolvimento de software.",
      freeAssess: "Avaliação Gratuita",
      assessDesc:
        "Avaliação abrangente de habilidades para identificar pontos fortes e áreas para melhoria, ajudando você a traçar o melhor caminho para seu desenvolvimento profissional.",
      whyChoose: "Por Que Escolher a Traincape Technology",
      whySubtitle: "O que nos diferencia de outros provedores",
      expInstructors: "Instrutores com Experiência na Indústria",
      instructorsDesc:
        "Aprenda com profissionais com experiência real em seus campos",
      handsOn: "Aprendizado Prático",
      handsOnDesc:
        "Treinamento orientado para a prática com projetos e exercícios do mundo real",
      careerSupport: "Suporte de Carreira",
      careerDesc:
        "Assistência com currículo, preparação para entrevistas e apoio na colocação profissional",
      customDev: "Desenvolvimento Personalizado",
      customDevDesc:
        "Aplicações web e móveis personalizadas projetadas para atender às suas necessidades específicas de negócios",
      modernTech: "Tecnologias Modernas",
      modernTechDesc:
        "Desenvolvimento utilizando os mais recentes frameworks e tecnologias para desempenho ideal",
      ongoingSupport: "Suporte Contínuo",
      supportDesc:
        "Manutenção e atualizações contínuas para garantir que suas aplicações permaneçam atualizadas",
      certPartners: "Nossos Parceiros de Certificação",
      partnersSubtitle:
        "Prepare-se para certificações reconhecidas globalmente com nossos programas de treinamento autorizados",
      viewCourses: "Ver Cursos",
      readyAdvance: "Pronto para Avançar em Sua Carreira de TI?",
      careerHelp:
        "Seja você está procurando obter certificação, aprimorar suas habilidades ou mudar completamente seu caminho profissional, estamos aqui para ajudá-lo a ter sucesso.",
      contactUs: "Entre em Contato",
      exploreCourses: "Explorar Cursos",
      comptiaDesc:
        "Prepare-se para certificações essenciais de TI como A+, Network+, Security+ e mais com nossos materiais de treinamento autorizados pela CompTIA e instrutores experientes.",
      pecbDesc:
        "Obtenha certificação em padrões ISO, gestão de riscos e segurança da informação com nossos programas de treinamento credenciados pelo PECB.",
      microsoftDesc:
        "Domine as tecnologias Microsoft com nossos programas de treinamento para certificações Azure, Microsoft 365 e de desenvolvedor.",
    },
  
    // Italian translations
    it: {
      footer: {
        aboutDesc:
          "Le metodologie specifiche di Traincape Technology per misurare e dare priorità alla soddisfazione del cliente. Molte aziende utilizzano diversi metodi per misurare e dare priorità alla soddisfazione del cliente.",
        workingTime: "Lun - Sab: 11AM - 7PM",
        address:
          "Khandolia Plaza, 118C, Dabri - Palam Rd, Vaishali, Vaishali Colony, Dashrath Puri, New Delhi, Delhi, 110045",
        links: "Link",
        explore: "Esplora",
        officeMap: "Mappa dell'ufficio",
        contactUs: "Contattaci",
        workingHours: "Orari di lavoro",
        officeAddress: "Indirizzo dell'ufficio",
        aboutUs: "Chi siamo",
        socialMediaLinks: "Link ai social media",
        faq: "FAQ",
        policy: "Politica",
        career: "Carriera",
        employee: "Dipendente",
        whatWeDo: "Cosa facciamo",
        resources: "Risorse",
        internship: "Stage",
        partners: "Partner",
        gallery: "Galleria",
        copyRight: "Copyright © " + new Date().getFullYear(),
        allRightsReserved: "Tutti i diritti riservati",
      },
      aboutHeader: "Chi è Traincape Technology",
      empowering:
        "Potenziare le carriere attraverso programmi di formazione e certificazione professionale IT",
      home: "Home",
      aboutUs: "Chi Siamo",
      ourStory: "La Nostra Storia",
      storySubtitle:
        "Il viaggio di Traincape Technology è iniziato con una visione per trasformare l'educazione informatica",
      founder: "Fondatore e CEO",
      storyPara1:
        "Traincape Technology è stata fondata nel 2021 da Parichay Singh Rana con la visione di rivoluzionare il modo in cui le aziende affrontano la tecnologia. Con anni di esperienza nel settore, abbiamo riconosciuto la necessità di un'azienda in grado di fornire soluzioni tecnologiche personalizzate, affidabili e all'avanguardia.",
      storyPara2:
        "La nostra missione è potenziare le aziende sfruttando le ultime tecnologie e innovazioni per guidare la crescita, l'efficienza e l'innovazione. Il nostro team di esperti ha un'ampia esperienza nello sviluppo e nell'implementazione di soluzioni software personalizzate, app mobili e applicazioni web che soddisfano le esigenze uniche dei nostri clienti.",
      storyPara3:
        "Oggi siamo orgogliosi di aver formato numerosi professionisti che hanno ottenuto ruoli in aziende tecnologiche leader. Le nostre partnership con i principali enti di certificazione ci permettono di offrire programmi di formazione completi riconosciuti a livello globale.",
      ourFoundation: "Le Nostre Fondamenta",
      foundationSubtitle:
        "I principi che guidano tutto ciò che facciamo a Traincape Technology",
      ourVision: "La Nostra Visione",
      visionDesc:
        "Essere il principale fornitore di educazione IT, riconosciuto per l'eccellenza nella formazione e nella produzione di professionisti pronti per l'industria che guidano l'innovazione tecnologica.",
      ourMission: "La Nostra Missione",
      missionDesc:
        "Potenziare gli individui attraverso programmi di formazione IT completi che combinano conoscenze teoriche con competenze pratiche, consentendo loro di eccellere nelle loro carriere.",
      ourValues: "I Nostri Valori",
      valuesDesc:
        "Eccellenza nell'educazione, integrità nel nostro approccio, innovazione nei nostri metodi e un impegno per il successo di ogni studente che si affida a noi per il proprio sviluppo professionale.",
      ourServices: "I Nostri Servizi",
      servicesSubtitle:
        "Formazione IT completa e soluzioni tecnologiche per far progredire la tua carriera",
      websiteDev: "Sviluppo di Siti Web",
      websiteDesc:
        "Soluzioni di siti web personalizzati adattati alle esigenze della tua azienda, da semplici siti informativi a piattaforme e-commerce complesse e applicazioni web.",
      appDev: "Sviluppo di App",
      appDesc:
        "Applicazioni mobili multi-piattaforma che offrono un'esperienza utente senza interruzioni su dispositivi iOS e Android, costruite con le ultime tecnologie.",
      certVouchers: "Voucher per Certificazioni",
      vouchersDesc:
        "Voucher per esami scontati per le principali certificazioni IT, rendendo il percorso verso la certificazione professionale più accessibile ed economico.",
      internship: "Programmi di Stage",
      internshipDesc:
        "Acquisisci esperienza pratica attraverso i nostri programmi di stage strutturati, lavorando su progetti reali sotto la guida di professionisti esperti.",
      profTraining: "Formazione Professionale",
      trainingDesc:
        "Formazione guidata da istruttori in vari domini IT, tra cui networking, cybersecurity, cloud computing e sviluppo software.",
      freeAssess: "Valutazione Gratuita",
      assessDesc:
        "Valutazione completa delle competenze per identificare punti di forza e aree di miglioramento, aiutandoti a tracciare il percorso migliore per il tuo sviluppo professionale.",
      whyChoose: "Perché Scegliere Traincape Technology",
      whySubtitle: "Cosa ci distingue dagli altri fornitori",
      expInstructors: "Istruttori con Esperienza nel Settore",
      instructorsDesc:
        "Impara da professionisti con esperienza reale nei loro campi",
      handsOn: "Apprendimento Pratico",
      handsOnDesc:
        "Formazione orientata alla pratica con progetti ed esercizi reali",
      careerSupport: "Supporto alla Carriera",
      careerDesc:
        "Assistenza per il curriculum, preparazione ai colloqui e supporto per il collocamento lavorativo",
      customDev: "Sviluppo Personalizzato",
      customDevDesc:
        "Applicazioni web e mobili personalizzate progettate per soddisfare le tue specifiche esigenze aziendali",
      modernTech: "Tecnologie Moderne",
      modernTechDesc:
        "Sviluppo utilizzando i più recenti framework e tecnologie per prestazioni ottimali",
      ongoingSupport: "Supporto Continuo",
      supportDesc:
        "Manutenzione e aggiornamenti continui per garantire che le tue applicazioni rimangano aggiornate",
      certPartners: "I Nostri Partner di Certificazione",
      partnersSubtitle:
        "Preparati per certificazioni riconosciute a livello globale con i nostri programmi di formazione autorizzati",
      viewCourses: "Visualizza Corsi",
      readyAdvance: "Pronto a Far Avanzare la Tua Carriera IT?",
      careerHelp:
        "Che tu stia cercando di ottenere una certificazione, migliorare le tue competenze o cambiare completamente il tuo percorso di carriera, siamo qui per aiutarti a avere successo.",
      contactUs: "Contattaci",
      exploreCourses: "Esplora i Corsi",
      comptiaDesc:
        "Preparati per le certificazioni IT fondamentali come A+, Network+, Security+ e altro ancora con i nostri materiali di formazione autorizzati CompTIA e istruttori esperti.",
      pecbDesc:
        "Ottieni la certificazione negli standard ISO, nella gestione del rischio e nella sicurezza delle informazioni con i nostri programmi di formazione accreditati PECB.",
      microsoftDesc:
        "Padroneggia le tecnologie Microsoft con i nostri programmi di formazione per le certificazioni Azure, Microsoft 365 e per sviluppatori.",
    },
  
    // Arabic translations
    ar: {
      footer: {
        aboutDesc:
          "منهجيات Traincape Technology الخاصة لقياس وإعطاء الأولوية لرضا العملاء. تستخدم العديد من الشركات أساليب متنوعة لقياس وإعطاء الأولوية لرضا العملاء.",
        workingTime: "الاثنين - السبت: 11AM - 7PM",
        address:
          "Khandolia Plaza, 118C, Dabri - Palam Rd, Vaishali, Vaishali Colony, Dashrath Puri, New Delhi, Delhi, 110045",
        links: "الروابط",
        explore: "استكشاف",
        officeMap: "خريطة المكتب",
        contactUs: "اتصل بنا",
        workingHours: "ساعات العمل",
        officeAddress: "عنوان المكتب",
        aboutUs: "من نحن",
        socialMediaLinks: "روابط الوسائل الاجتماعية",
        faq: "الأسئلة الشائعة",
        policy: "السياسة",
        career: "الوظائف",
        employee: "الموظف",
        whatWeDo: "ماذا نفعل",
        resources: "الموارد",
        internship: "التدريب الداخلي",
        partners: "الشركاء",
        gallery: "المعرض",
        copyRight: "حقوق الطبع والنشر © " + new Date().getFullYear(),
        allRightsReserved: "جميع الحقوق محفوظة",
      },
      aboutHeader: "عن تكنولوجيا ترينكايب",
      empowering:
        "تمكين الحياة المهنية من خلال التدريب المهني في تكنولوجيا المعلومات وبرامج الشهادات",
      home: "الصفحة الرئيسية",
      aboutUs: "من نحن",
      ourStory: "قصتنا",
      storySubtitle:
        "بدأت رحلة تكنولوجيا ترينكايب برؤية لتحويل التعليم في تكنولوجيا المعلومات",
      founder: "المؤسس والرئيس التنفيذي",
      storyPara1:
        "تأسست تكنولوجيا ترينكايب في عام 2021 بواسطة بارشاي سينغ رانا برؤية لإحداث ثورة في طريقة تعامل الشركات مع التكنولوجيا. ومع سنوات من الخبرة في الصناعة، أدركنا الحاجة إلى شركة قادرة على تقديم حلول تكنولوجية مخصصة وموثوقة ومتطورة.",
      storyPara2:
        "مهمتنا هي تمكين الشركات من خلال الاستفادة من أحدث التقنيات والابتكارات لتحقيق النمو والكفاءة والابتكار. يمتلك فريقنا من الخبراء خبرة واسعة في تطوير وتنفيذ حلول البرمجيات المخصصة، وتطبيقات الهواتف المحمولة، وتطبيقات الويب التي تلبي الاحتياجات الفريدة لعملائنا.",
      storyPara3:
        "اليوم، نحن فخورون بتدريب العديد من المحترفين الذين حصلوا على وظائف مع شركات تكنولوجيا رائدة. شراكاتنا مع الهيئات المعتمدة تمنحنا القدرة على تقديم برامج تدريب شاملة معترف بها عالميًا.",
      ourFoundation: "مؤسستنا",
      foundationSubtitle: "المبادئ التي توجه كل ما نقوم به في تكنولوجيا ترينكايب",
      ourVision: "رؤيتنا",
      visionDesc:
        "أن نكون المزود الرائد لتعليم تكنولوجيا المعلومات، معترفًا به للتميز في التدريب وإنتاج محترفين جاهزين للصناعة يقودون الابتكار التكنولوجي.",
      ourMission: "مهمتنا",
      missionDesc:
        "تمكين الأفراد من خلال برامج تدريب شاملة في تكنولوجيا المعلومات تجمع بين المعرفة النظرية والمهارات العملية، مما يمكنهم من التفوق في حياتهم المهنية.",
      ourValues: "قيمنا",
      valuesDesc:
        "التميز في التعليم، النزاهة في نهجنا، الابتكار في طرقنا، والالتزام بنجاح كل طالب يثق بنا في تطويره المهني.",
      ourServices: "خدماتنا",
      servicesSubtitle:
        "تدريب شامل في تكنولوجيا المعلومات وحلول تكنولوجية لتعزيز حياتك المهنية",
      websiteDev: "تطوير المواقع الإلكترونية",
      websiteDesc:
        "حلول مواقع الإنترنت المخصصة التي تلبي احتياجات عملك، من المواقع البسيطة إلى منصات التجارة الإلكترونية المعقدة وتطبيقات الويب.",
      appDev: "تطوير التطبيقات",
      appDesc:
        "تطبيقات الهواتف المحمولة متعددة المنصات التي توفر تجارب مستخدم سلسة عبر أجهزة iOS وAndroid، تم بناؤها باستخدام أحدث التقنيات.",
      certVouchers: "قسائم الشهادات",
      vouchersDesc:
        "قسائم امتحانات مخفضة لشهادات تكنولوجيا المعلومات الرئيسية، مما يجعل الطريق إلى الشهادات المهنية أكثر affordability وقابلة للوصول.",
      internship: "برامج التدريب",
      internshipDesc:
        "احصل على خبرة عملية من خلال برامج التدريب المنظمة لدينا، والعمل على مشاريع حقيقية تحت إشراف مهنيين ذوي خبرة.",
      profTraining: "التدريب المهني",
      trainingDesc:
        "التدريب بقيادة معلمين في مجالات تكنولوجيا المعلومات المختلفة، بما في ذلك الشبكات، الأمن السيبراني، الحوسبة السحابية، وتطوير البرمجيات.",
      freeAssess: "تقييم مجاني",
      assessDesc:
        "تقييم شامل للمهارات لتحديد نقاط القوة والمجالات التي تحتاج إلى تحسين، مما يساعدك في تحديد أفضل مسار لتطويرك المهني.",
      whyChoose: "لماذا تختار تكنولوجيا ترينكايب",
      whySubtitle: "ما يميزنا عن المزودين الآخرين",
      expInstructors: "مدربون ذو خبرة في الصناعة",
      instructorsDesc: "تعلم من محترفين لديهم خبرة عملية في مجالاتهم",
      handsOn: "التعلم العملي",
      handsOnDesc: "تدريب عملي مع مشاريع وتمارين واقعية",
      careerSupport: "دعم الحياة المهنية",
      careerDesc: "مساعدة في كتابة السيرة الذاتية، تحضير للمقابلات، ودعم التوظيف",
      customDev: "التطوير المخصص",
      customDevDesc:
        "تطبيقات الويب والهاتف المحمول المصممة لتلبية احتياجات عملك الخاصة",
      modernTech: "التقنيات الحديثة",
      modernTechDesc:
        "التطوير باستخدام أحدث الإطارات والتقنيات للحصول على أداء مثالي",
      ongoingSupport: "الدعم المستمر",
      supportDesc: "صيانة وتحديثات مستمرة لضمان بقاء تطبيقاتك محدثة",
      certPartners: "شركاؤنا في الشهادات",
      partnersSubtitle:
        "استعد لشهادات معترف بها عالميًا من خلال برامج التدريب المعتمدة لدينا",
      viewCourses: "عرض الدورات التدريبية",
      readyAdvance: "هل أنت مستعد لتطوير حياتك المهنية في تكنولوجيا المعلومات؟",
      careerHelp:
        "سواء كنت تبحث عن شهادة، تحسين مهاراتك، أو تغيير مسار حياتك المهنية بالكامل، نحن هنا لمساعدتك على النجاح.",
      contactUs: "اتصل بنا",
      exploreCourses: "استكشاف الدورات التدريبية",
      comptiaDesc:
        "استعد للحصول على الشهادات الأساسية في تكنولوجيا المعلومات مثل A+ وNetwork+ وSecurity+ وأكثر باستخدام مواد تدريب معتمدة من CompTIA ومدربين ذوي خبرة.",
      pecbDesc:
        "احصل على شهادة في معايير ISO، إدارة المخاطر، وأمن المعلومات من خلال برامج التدريب المعتمدة من PECB.",
      microsoftDesc:
        "اتقن تقنيات مايكروسوفت من خلال برامج التدريب لدينا لشهادات Azure وMicrosoft 365 والشهادات الخاصة بالمطورين.",
    },
  };
  
  export default translations;